import { useEffect, useMemo, useState, useRef } from "react"
import { useLocation } from 'react-router-dom'
import { Button, Table, Select, message, Space } from 'antd'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

import 'moment/locale/zh-cn';

const { Column } = Table
const { Option } = Select

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    store_id: string | undefined,
    menu_date: any,
}

export default function () {

    const Location: any = useLocation()
    const currentsRef = useRef(0)
    const mealTimesRef = useRef(1)

    let fetchOtherParamsTmpl: fetchParams = {
        menu_date: Location.state.dining_date,
        store_id: Location.state.store_id
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [pagination2, setPagination2] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [pagination3, setPagination3] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [data, setData] = useState<any>([])
    const [data2, setData2] = useState<any>([])
    const [data3, setData3] = useState<any>([])

    // 订单视图类型
    const [current, setCurrent] = useState<number>(0)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch(pagination)
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleTableChange = (antPagination: any) => {
        let p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
        fetch(p)
    }

    const handleTableChange2 = (antPagination: any) => {
        const p = { ...pagination2 }
        p.current = antPagination.current

        setPagination2(p)
        fetch2(p)
    }

    const handleTableChange3 = (antPagination: any) => {
        const p = { ...pagination3 }
        p.current = antPagination.current

        setPagination3(p)
        fetch3(p)
    }

    const handleSearch = () => {
        if (currentsRef.current === 0) {
            const p = { ...pagination }
            p.current = 1
            fetch(p)

        } else if (currentsRef.current == 1) {
            const p = { ...pagination2 }
            p.current = 1
            fetch2(p)

        } else {
            const p = { ...pagination3 }
            p.current = 1
            fetch3(p)
        }
    }

    const fetch = (pagination: any) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params = {
            meal_times: mealTimesRef.current,
            menu_date: Location.state.dining_date,
            store_id: Location.state.store_id
        }

        axiosTable.get('/cooking_center/kitchen/dining_order/by_room_number/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const fetch2 = (pagination2: any) => {
        setLoading(true)

        const iPagination: any = { ...pagination2 }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params = {
            meal_times: mealTimesRef.current,
            menu_date: Location.state.dining_date,
            store_id: Location.state.store_id
        }

        axiosTable.get('cooking_center/kitchen/dining_order/by_menu_item/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination2 }
                p.total = response.total

                setPagination2(p)
                setData2(response.records)
            }

            setLoading(false)
        })
    }

    const fetch3 = (pagination3: any) => {
        setLoading(true)

        const iPagination: any = { ...pagination3 }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params = {
            meal_times: mealTimesRef.current,
            menu_date: Location.state.dining_date,
            store_id: Location.state.store_id
        }

        axiosTable.get('/cooking_center/kitchen/dining_order/by_position/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination3 }
                p.total = response.total

                setPagination3(p)
                setData3(response.records)
            }

            setLoading(false)
        })
    }

    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')

        let params = {
            meal_times: mealTimesRef.current,
            menu_date: Location.state.dining_date,
            store_id: Location.state.store_id
        }

        if (currentsRef.current === 0) {
            baseAxiosComplete('/cooking_center/kitchen/dining_order/by_room_number/export', {
                params: {
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }

        if (currentsRef.current === 1) {
            baseAxiosComplete('/cooking_center/kitchen/dining_order/by_menu_item/export', {
                params: {
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }

        if (currentsRef.current === 2) {
            baseAxiosComplete('/cooking_center/kitchen/dining_order/by_position/export', {
                params: {
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }
    }

    return (<div className="common-page">
        {/* 膳食中心 -> 厨房管理 -> 客餐订单管理 -> 查看详情 */}
        <BreadCrumb position={['膳食中心', '客餐订单详情']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Select placeholder="按房号、菜品、岗位分类" style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={current}
                    onChange={(v: number) => {
                        setCurrent(v)
                        currentsRef.current = v
                        handleSearch()
                    }}>
                    <Option key={0} value={0}>房号</Option>
                    <Option key={1} value={1}>菜品</Option>
                    <Option key={2} value={2}>岗位分类</Option>
                </Select>

                <Select placeholder="餐次" style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={mealTimesRef.current}
                    onChange={(v: number) => {
                        mealTimesRef.current = v
                        handleChange(v, 'meal_times')
                        handleSearch()
                    }}>
                    <Option value={1} key={1}>早餐</Option>
                    <Option value={2} key={2}>加餐</Option>
                    <Option value={3} key={3}>午餐</Option>
                    <Option value={4} key={4}>间餐</Option>
                    <Option value={5} key={5}>晚餐</Option>
                    <Option value={6} key={6}>宵夜</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="primary" >下载总单</Button>
                {/* <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { window.history.go(-1) }} >返回</Button> */}
            </div>
        </div>

        <div className="common-main">
            {currentsRef.current === 0 && <Table
                dataSource={data} scroll={{ x: 'max-content' }} bordered={true}
                rowKey="check_in_id" loading={loading} pagination={pagination}
                onChange={handleTableChange}>
                <Column title="用餐日期" dataIndex="menu_date" key="menu_date" />
                <Column title="房号" dataIndex="room_number" key="room_number" />
                <Column title="阶段" dataIndex="stage_number_desc" key="stage_number_desc" />
                <Column title="餐次" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="服务对象" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="营养师" dataIndex="belong_dietician_name" key="belong_dietician_name" />
                <Column title="菜品" dataIndex="menu_item_list" key="menu_item_list" render={(v: any[]) => {
                    return <Space>
                        {v.map((el => {
                            let s = ''
                            switch (el.sugar_status) {
                                case 0:
                                    s = '默认'
                                    break;
                                case 1:
                                    s = '去糖'
                                    break;
                                case 2:
                                    s = '少糖'
                                    break;
                                case 3:
                                    s = '多糖'
                                    break;
                            }

                            let s2 = ''
                            switch (el.salt_status) {
                                case 0:
                                    s2 = '默认'
                                    break;
                                case 1:
                                    s2 = '去盐'
                                    break;
                                case 2:
                                    s2 = '少盐'
                                    break;
                                case 3:
                                    s2 = '多盐'
                                    break;
                            }

                            let s3 = el.preference_desc

                            return <span>
                                {el.menu_item_name}
                                {s !== '默认' && <i style={{ color: 'orange', fontStyle: 'normal' }}>({s}) </i>}
                                {s2 !== '默认' && <i style={{ color: 'orange', fontStyle: 'normal' }}>({s2}) </i>}
                                {s3 && <i style={{ color: 'orange', fontStyle: 'normal' }}>({s3}) </i>}
                                <i style={{ color: 'red', fontStyle: 'normal' }}>【{el.menu_item_count}】</i>
                            </span>
                        }))}
                    </Space>
                }} />

                <Column title="下单人" dataIndex="order_operator_name" key="order_operator_name" />
                <Column title="下单时间" dataIndex="order_time" key="order_time" />
            </Table>}

            {currentsRef.current === 1 && <Table
                dataSource={data2} scroll={{ x: 'max-content' }} bordered={true}
                pagination={pagination2} loading={loading}
                onChange={handleTableChange2}>
                <Column title="用餐日期" dataIndex="menu_date" key="menu_date" />
                <Column title="餐次" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="菜品" render={(v: any) => {
                    let s = ''
                    switch (v.sugar_status) {
                        case 0:
                            s = '默认'
                            break;
                        case 1:
                            s = '去糖'
                            break;
                        case 2:
                            s = '少糖'
                            break;
                        case 3:
                            s = '多糖'
                            break;
                    }

                    let s2 = ''
                    switch (v.salt_status) {
                        case 0:
                            s2 = '默认'
                            break;
                        case 1:
                            s2 = '去盐'
                            break;
                        case 2:
                            s2 = '少盐'
                            break;
                        case 3:
                            s2 = '多盐'
                            break;
                    }

                    return <span>
                        {v.menu_item_name}

                        {/* {s !== '默认' && <i style={{ color: 'orange', fontStyle: 'normal' }}>,({s})</i>}
                        {s2 !== '默认' && <i style={{ color: 'orange', fontStyle: 'normal' }}>,({s2})</i>}
                        {<i style={{ color: 'red', fontStyle: 'normal' }}>,总数【{v.total_menu_item_count}】</i>} */}
                    </span>
                }} />

                <Column title="房号" dataIndex="room_number_list" key="room_number_list" render={(v: []) => {
                    return <Space>
                        {v.map((el: any) => <Space>
                            <span>{el.room_number}</span><span style={{ color: 'red' }}>【{el.menu_item_count}】</span>、
                        </Space>)}
                    </Space>
                }} />
                <Column title="口味偏好" dataIndex="taste_favors" key="taste_favors" />
                <Column title="总数量" dataIndex="total_menu_item_count" key="total_menu_item_count" />
            </Table>}

            {currentsRef.current === 2 && <Table
                dataSource={data3} scroll={{ x: 'max-content' }} bordered={true}
                loading={loading} pagination={pagination3} onChange={handleTableChange3}>
                <Column title="用餐日期" dataIndex="menu_date" key="menu_date" />
                <Column title="餐次" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="岗位" dataIndex="position_name" key="position_name" />
                <Column title="菜品" dataIndex="menu_item_list" key="menu_item_list" render={(v: any[]) => {
                    return <Space>
                        {v && v.map((el => {
                            let s = ''
                            switch (el.sugar_status) {
                                case 0:
                                    s = '默认'
                                    break;
                                case 1:
                                    s = '去糖'
                                    break;
                                case 2:
                                    s = '少糖'
                                    break;
                                case 3:
                                    s = '多糖'
                                    break;
                            }

                            let s2 = ''
                            switch (el.salt_status) {
                                case 0:
                                    s2 = '默认'
                                    break;
                                case 1:
                                    s2 = '去盐'
                                    break;
                                case 2:
                                    s2 = '少盐'
                                    break;
                                case 3:
                                    s2 = '多盐'
                                    break;
                            }

                            let s3 = el.preference_desc

                            return <span>
                                {el.menu_item_name}{s !== '默认' && <i style={{ color: 'orange', fontStyle: 'normal' }}>({s})</i>}
                                {s2 !== '默认' && <i style={{ color: 'orange', fontStyle: 'normal' }}>,({s2})</i>}
                                {s3 && <i style={{ color: 'orange', fontStyle: 'normal' }}>({s3}) </i>}
                                <i style={{ color: 'red', fontStyle: 'normal' }}>【{el.menu_item_count}】</i>
                            </span>
                        }))}
                    </Space>
                }} />
            </Table>}
        </div>
    </div>)
}